<template>
  <span class="text-sm px-2 py-1 rounded-md border" :class="toneClasses">
    <slot />
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

// Tailwind scans templates for whole class names, so the tones are spelled out
// rather than built from the prop.
const TONES: Record<string, string> = {
  green: 'text-green-600 bg-green-50 border-green-600',
  red: 'text-red-700 bg-red-50 border-red-700',
  amber: 'text-amber-700 bg-amber-50 border-amber-700',
  grey: 'text-gray-600 bg-gray-50 border-gray-400',
};

const props = withDefaults(defineProps<{ tone?: 'green' | 'red' | 'amber' | 'grey' }>(), {
  tone: 'green',
});

const toneClasses = computed(() => TONES[props.tone] ?? TONES.green);
</script>
